.root:global(.MuiDialog-root) {
  z-index: 1700;
}

.container {
  align-items: center !important;
}

.paper:global(.MuiDialog-paper) {
  background: var(--pm-surface);
  border-radius: 1.25rem;
  color: var(--pm-text-primary);
  overflow: hidden;
  width: calc(100% - 2rem);
  max-width: 52rem !important;
  max-height: calc(100dvh - 2rem) !important;
  margin: 1rem !important;
}

.header {
  align-items: center;
  border-bottom: 1px solid var(--pm-border);
  display: flex;
  flex-shrink: 0;
  gap: 1rem;
  justify-content: space-between;
  padding: 1.25rem;
}

.title {
  color: inherit;
  font-family: var(--pm-font-family);
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: -0.03rem;
  line-height: 1.2;
  margin: 0;
}

.closeButton {
  flex-shrink: 0;
}

.content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden !important;
  padding: 0 !important;
}

.frame {
  background: var(--pm-surface);
  border: 0;
  display: block;
  flex: 1 1 auto;
  height: 65dvh;
  min-height: 0;
  width: 100%;
}

.loading {
  margin: 0;
  padding: 1rem;
}
